var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1416 5.9214L12.8204 5.91665C7.52574 5.90399 2.92932 10.2059 2.89291 15.4167V21.4175C2.89291 22.6683 2.73457 23.8891 2.05216 24.9293L1.59774 25.6228C0.905824 26.6742 1.64999 28.0833 2.89291 28.0833H25.1071C26.35 28.0833 27.0926 26.6742 26.4022 25.6228L25.9478 24.9293C25.267 23.8891 25.1071 22.6667 25.1071 21.4159V15.4182C25.0437 10.2059 20.4362 5.93407 15.1416 5.9214V5.9214Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 28.0833C18.75 29.343 18.2496 30.5512 17.3588 31.442C16.468 32.3328 15.2598 32.8333 14 32.8333C12.7402 32.8333 11.532 32.3328 10.6412 31.442C9.75044 30.5512 9.25 29.343 9.25 28.0833",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 1.16663C14.8398 1.16663 15.6452 1.50026 16.2391 2.09412C16.833 2.68799 17.1666 3.49344 17.1666 4.33329V5.91663H10.8333V4.33329C10.8333 3.49344 11.1669 2.68799 11.7607 2.09412C12.3546 1.50026 13.1601 1.16663 13.9999 1.16663Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBlack);
export default __webpack_public_path__ + "static/media/bellBlack.5f276d37251f6fc98bdc02e9e38181fb.svg";
export { ForwardRef as ReactComponent };